import React, {useState} from 'react';
import {RxCross1} from 'react-icons/rx';
import IpComponentWrap from './IpComponentWrap';
import Security2FaPopUp from './Security2FaPopUp';
import './securityComponent.scss';

const SecuritySettings = ({securityKey}) => {
  const [isEnable, setIsEnable] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="security_component_wrap">
      <h3>Security</h3>
      <div className="security_component_item">
        <div className="security_component_item_header">
          <h4>Backup Security Key</h4>
          <p>The key that will be used to access restore and ownership verification</p>
        </div>
        <div className="security_component_item_body">
          <div className="security_component_item_body_bg">
            <p>{securityKey}</p>
          </div>
        </div>
        <div className="security_component_item_alert">
          <img src="/img/info.svg" alt="" />
          <p>
            For security purposes, tokens can only be viewed once, when created. If you forgot or
            lost access to your token, please regenerate a new one.
          </p>
        </div>
        <button className="btn btn_prime">Reset Key</button>
      </div>
      <div className="security_component_item">
        <div className="security_component_item_header">
          <h4>2FA</h4>
          <p>
            Additional layer of security by requiring users to enter a unique authentication code
            generated
          </p>
        </div>
        <div className="security_component_item_body-button">
          <button className={isEnable ? 'btn_decor_green' : 'btn_decor_red'} disabled>
            {isEnable ? 'Enabled' : 'Disabled'}
          </button>
          {isEnable ? (
            <button className="btn btn_second_border" onClick={() => setIsOpen(true)}>
              Reset 2FA
            </button>
          ) : (
            <button className="btn btn_second_border" onClick={() => setIsOpen(true)}>
              Enable 2FA
            </button>
          )}
        </div>
        {isOpen && <Security2FaPopUp setIsOpen={setIsOpen} setIsEnable={setIsEnable} />}
      </div>
      <div className="security_component_item">
        <div className="security_component_item_header">
          <h4>IP Whitelisting</h4>
          <p>Sleek and secure method of restricting access to only trusted IPs</p>
        </div>
        <div className="security_component_item_body">
          <div className="security_component_item_body_bg">
            <IpComponentWrap />
          </div>
        </div>
      </div>
      <div className="security_component_item_btn">
        <button className="btn btn_second">Cancel</button>
        <button className="btn btn_prime">Save</button>
      </div>
    </div>
  );
};

export default SecuritySettings;
